import { MovementItemResponsiveProps } from '.';

export const formatMovementData = ({
  grossValue,
  historic,
  iofValue,
  irValue,
  movementDate,
  netValue,
  penaltyValue,
  quotaQuantity,
  quotaValue,
  quotationDate,
}: MovementItemResponsiveProps) => {
  return [
    {
      label: 'Data de movimento',
      value: movementDate,
    },
    {
      label: 'Cotização',
      value: quotationDate,
    },
    {
      label: 'Histórico',
      value: historic,
    },
    {
      label: 'Cota',
      value: quotaValue,
    },
    {
      label: 'Quantidade',
      value: quotaQuantity,
    },
    {
      label: 'Valor bruto',
      value: grossValue,
    },
    {
      label: 'IR',
      value: irValue,
    },
    {
      label: 'IOF',
      value: iofValue,
    },
    {
      label: 'Penalidade',
      value: penaltyValue,
    },
    {
      label: 'Valor líquido',
      value: netValue,
    },
  ];
};
